import { cva } from 'class-variance-authority';

export const raceSectionHeadingVariants = cva(
  'scroll-mt-20 border-l-4 border-primary pl-4 text-[18px] font-semibold leading-snug'
);

export const raceSectionMetaVariants = cva(
  'shrink-0 text-[14px] font-normal leading-snug text-[#a7adb4]'
);
